import { Icons, SingleCombobox } from '@commenda/kakashi';
import { DEFAULT_DATE_OPTIONS } from './constants';
import { DateFilterProps } from './types';
import { classNames } from '@commenda/utils';

export const DateFilter = ({
  value,
  onChange,
  options = DEFAULT_DATE_OPTIONS,
  placeholder = 'Period',
  disabled = false,
}: DateFilterProps) => {
  return (
    <SingleCombobox
      options={options}
      value={value || ''}
      setValue={onChange}
      placeholder={placeholder}
      _optionsClassName="min-w-[220px]"
      _className="h-10"
      canClearSelection={false}
      useRenderTriggerForPlaceholder
      hideSearch
      disabled={disabled}
      renderOption={({ option, isSelected }) => (
        <div className="flex items-center justify-between w-48">
          <span className="txt-medium-regular text-button-secondary-fg truncate">
            {option.label}
          </span>
          <div className="w-4 shrink-0 ml-2">
            {isSelected && <Icons.Check className="size-4" />}
          </div>
        </div>
      )}
      renderTrigger={() => (
        <span className={classNames("txt-small-medium !text-button-secondary-fg truncate", disabled && 'cursor-not-allowed')}>
          {placeholder}
        </span>
      )}
    />
  );
};
